import { render, staticRenderFns } from "./aggrid-neraca.vue?vue&type=template&id=47c785f5&scoped=true&"
import script from "./aggrid-neraca.vue?vue&type=script&lang=js&"
export * from "./aggrid-neraca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c785f5",
  null
  
)

export default component.exports